"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeSegmentMaskKeys = exports.popupTimePickerDefaultProps = exports.defaultTimeAriaLabels = exports.REGEXP_TIME_24H = exports.REGEXP_TIME_12H = exports.POPUP_TIME_PICKER_VERTICAL_PADDING = exports.POPUP_TIME_PICKER_POPOVER_WIDTH = exports.POPUP_TIME_PICKER_MASK_24_HOURS = exports.POPUP_TIME_PICKER_MASK_12_HOURS = exports.POPUP_TIME_PICKER_DEFAULT_WIDTH = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _popover = require("../../popover");

var _text = require("../../text");

var _utils = require("../../utils");

var _core = require("@emotion/core");

var _popupTimePickerPopov;

var timeSegmentMaskKeys = {
  hours: 'hh',
  minutes: 'mm',
  seconds: 'ss',
  milliseconds: 'sss'
};
exports.timeSegmentMaskKeys = timeSegmentMaskKeys;
var defaultTimeAriaLabels = {
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  milliseconds: 'Milliseconds',
  period: 'Period',
  increase: {
    hours: 'hours (hh) increase',
    minutes: 'minutes (mm) increase',
    seconds: 'seconds (ss) increase',
    milliseconds: 'milliseconds (sss) increase',
    period: 'period am/pm change'
  },
  decrease: {
    hours: 'hours (hh) decrease',
    minutes: 'minutes (mm) decrease',
    seconds: 'seconds (ss) decrease',
    milliseconds: 'milliseconds (sss) decrease',
    period: 'period am/pm change'
  }
};
exports.defaultTimeAriaLabels = defaultTimeAriaLabels;

var defaultLabelRenderer = function defaultLabelRenderer(_ref) {
  var htmlFor = _ref.htmlFor,
      labelText = _ref.labelText,
      hasError = _ref.hasError;
  return (0, _core.jsx)(_text.Label, {
    color: hasError ? _utils.LABEL_ERROR_COLOR : _utils.LABEL_COLOR,
    htmlFor: htmlFor
  }, labelText);
};

var POPOVER_TOP_OFFSET = 24;
var popupTimePickerPopoverOffsetDefaultProps = (_popupTimePickerPopov = {}, (0, _defineProperty2.default)(_popupTimePickerPopov, _popover.PopoverPosition.TopCenter, [0, POPOVER_TOP_OFFSET]), (0, _defineProperty2.default)(_popupTimePickerPopov, _popover.PopoverPosition.TopTrailing, [0, POPOVER_TOP_OFFSET]), (0, _defineProperty2.default)(_popupTimePickerPopov, _popover.PopoverPosition.TopLeading, [0, POPOVER_TOP_OFFSET]), _popupTimePickerPopov);
var popupTimePickerDefaultProps = {
  clearButtonAltText: 'Clear value',
  timePickerButtonAltText: 'Time picker',
  renderLabel: defaultLabelRenderer,
  popoverProps: {
    position: _popover.PopoverPosition.BottomCenter,
    offset: popupTimePickerPopoverOffsetDefaultProps
  }
};
exports.popupTimePickerDefaultProps = popupTimePickerDefaultProps;
var POPUP_TIME_PICKER_POPOVER_WIDTH = 200;
exports.POPUP_TIME_PICKER_POPOVER_WIDTH = POPUP_TIME_PICKER_POPOVER_WIDTH;
var POPUP_TIME_PICKER_DEFAULT_WIDTH = 200;
exports.POPUP_TIME_PICKER_DEFAULT_WIDTH = POPUP_TIME_PICKER_DEFAULT_WIDTH;
var POPUP_TIME_PICKER_VERTICAL_PADDING = 'S200';
exports.POPUP_TIME_PICKER_VERTICAL_PADDING = POPUP_TIME_PICKER_VERTICAL_PADDING;
var anyDigit = /[0-9]/;
var aOrP = /a|p|A|P/;
var m = /m|M/;
var REGEXP_TIME_24H = /\d\d:\d\d/;
exports.REGEXP_TIME_24H = REGEXP_TIME_24H;
var REGEXP_TIME_12H = /\d\d:\d\d [apAP][mM]/;
exports.REGEXP_TIME_12H = REGEXP_TIME_12H;
var POPUP_TIME_PICKER_MASK_12_HOURS = [anyDigit, anyDigit, ':', anyDigit, anyDigit, ' ', aOrP, m];
exports.POPUP_TIME_PICKER_MASK_12_HOURS = POPUP_TIME_PICKER_MASK_12_HOURS;
var POPUP_TIME_PICKER_MASK_24_HOURS = [anyDigit, anyDigit, ':', anyDigit, anyDigit];
exports.POPUP_TIME_PICKER_MASK_24_HOURS = POPUP_TIME_PICKER_MASK_24_HOURS;